<template>
  <div class="finance-page page-padding-top">
    <top-bar :title="i18n.t('finance.title3')" @back="back" ></top-bar>

    <div class="top-info flex-column-start-center banner2">
      <div class="title">{{$t('finance.desc1')}}</div>
      <div class="sub-title">{{$t('finance.desc2')}}</div>
    </div>

    <div class="finance-info white">
      <div class="flex-column-start-center total">
        <span class="desc">{{i18n.t('finance.label2')}}</span>
        <div class="count">{{statisticsData.Amount ? parseFloat(statisticsData.Amount).toFixed(4) : '0.0000'}}</div>
      </div>

      <div class=" statistics ">
        <div class="flex-center-between statistics-line">
          <div class="flex-1 flex-column-start-center">
            <div class="label">{{i18n.t('finance.label5')}}</div>
            <div class="count">{{userMoney ? parseFloat(userMoney).toFixed(4) : '0.0000'}}</div>
          </div>
          <div class="flex-1 flex-column-center">
            <div class="label">{{i18n.t('finance.label4')}}</div>
            <div class="count">{{statisticsData.Income ? parseFloat(statisticsData.Income).toFixed(4) : '0.0000'}}</div>
          </div>
          <div class="flex-1 flex-column-end-center">
            <div class="label">{{i18n.t('finance.label6')}}</div>
            <div class="count">{{statisticsData.YesterdayIncome ? parseFloat(statisticsData.YesterdayIncome).toFixed(4) : '0.0000'}}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="tabs flex">
      <div class="tab" :class="tabIndex == 0 ? 'active' : ''" @click="changeTab(0)">{{$t('finance.tab3')}}</div>
      <div class="tab" :class="tabIndex == 2 ? 'active' : ''" @click="changeTab(2)">{{$t('finance.tab4')}}</div>
      <div class="tab" :class="tabIndex == 1 ? 'active' : ''" @click="changeTab(1)">{{$t('finance.tab5')}}</div>
    </div>

    <div class="position-list">

      <div class="list " v-for="(item, i) in financeDataList" :key="i" @click="toDetail(item)">
        <div class="flex-center-between name">
          <div class="flex-center">
            <img :src="item.FinancialSetup.Currency.Logo ? `/upload/${item.FinancialSetup.Currency.Logo}` : bitUrl" alt="">
            <span>{{item.FinancialSetup.Currency.Name}}</span>
          </div>
          <div class="tag">
            {{item.FinancialSetup.ProductType === 1 ? $t('finance.label13') : $t('finance.label14')}}
          </div>
        </div>
        <div class="flex-center-between line">
          <div class="label">{{i18n.t('finance.label12')}}</div>
          <div class="count" :class="tabIndex == 3 ? 'red' : 'green'">{{$t(`finance.tab${tabIndex + 2}`)}}</div>
        </div>
        <div class="flex-center-between line">
          <div class="label">{{i18n.t('finance.label10')}}</div>
          <div class="count">{{item.FinancialSetup.IncomeRatio}}%</div>
        </div>
        <div class="flex-center-between line">
          <div class="label">{{i18n.t('finance.label9')}}</div>
          <div class="count">{{parseFloat(item.OrderAmount).toFixed(2)}} USDT</div>
        </div>
        <div class="flex-center-between line">
          <div class="label">{{i18n.t('finance.label19')}}</div>
          <div class="count">{{parseFloat(item.IncomeAmount).toFixed(2)}} USDT</div>
        </div>
       
        
      </div>
      <div class="empty-box flex-column-center" v-if="isInit && financeDataList.length == 0">
        <img :src="emptyUrl" alt="">
        <span>{{$t('common.empty')}}</span>
      </div>
    </div>
  </div>
</template>
<script>
import { Button, List } from 'vant'
import topBar from '@/components/topBar'
import { financeSetupList, financeList, financialStatistics } from '@/api/finance'
import { wallet } from '@/api/assest'
export default {
  components: {
    topBar,
    Button,
    List
  },
  data() {
    return {
      rightUrl: require('../../assets/imgs/icon-arrow-right.png'),
      bitUrl: require('../../assets/imgs/bit1.png'),
      emptyUrl: require('../../assets/imgs/empty.png'),
      page: {
        page: 1,
        limit: 10
      },
      userMoney: 0,
      isInit: false,
      loading: false,
      finished: false,
      totalPage: 1,
      tabIndex: 0,
      finishedText: '',
      financeDataList: [], //申购产品列表
      ownerFinanceList: [], //已申购列表
      statisticsData: {}
    }
  },
  mounted() {
    this.init()
    this.initFinance()
    this.initStatistics()
  },
  methods: {
    init() {
      let form = new FormData()
      form.append('ShortName', 'usdt')
      form.append('current', 1)
      form.append('pageSize', 10)
      wallet(form).then(res => {
        let data = res.data.Items[0]
        if (data) {
          this.userMoney = parseFloat(data.FinanceUse)
        }
      })
    },
    initStatistics() {
      financialStatistics().then(res => {
        this.statisticsData = res.data
        this.isInit = true
      })
    },
    initFinance() {
      let form = new FormData()
      form.append('current', 1)
      form.append('pageSize', 100)
      financeList(form).then(res => {
        this.ownerFinanceList = res.data.Items

        this.financeDataList = this.ownerFinanceList.filter(v => {
          return v.Status == this.tabIndex
        })
      })
    },
    onLoad() {
      this.page.page += 1
      this.init(true)
    },
    toDetail(data) {
      sessionStorage.setItem('financeData', JSON.stringify(data))
      this.$router.push({
        path: '/financeDetail',
        query: {
          type: this.tabIndex
        }
      })
    },
    changeTab(i) {
      this.tabIndex = i
      this.page.page = 1
      this.initFinance()
    },
    back() {
      this.$router.go(-1)
    }
  }
}
</script>